const visualization = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M1 5.31h4V15H1zm5-2.16h4V15H6zM11 1h4v14h-4z"/></svg>',
};

export { visualization as default };
